import { useEffect } from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { Submission } from "@/models/database/submissions/Submission.model";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useSubmissionsStore } from "@/store/submissions/submissions.store";

export const useSubmissions = (status: "approved" | "rejected" | "pending") => {
  const user = useCurrentUserProfile((s) => s.user);

  const { submissions, loading, error, setSubmissions, setLoading, setError } =
    useSubmissionsStore();

  const fetchData = async () => {
    if (!user) {
      return;
    }

    try {
      setLoading(true);
      const submissionsArray: Submission[] = [];

      const ref = collectionRef
        .submissions(brand.tenantId)
        .where("status", "==", status);
      const query = await ref.get();

      // Get news from Firestore
      query.docs.map(async (doc) => {
        const data = doc.data();
        const submission = {
          id: doc.id,
          ...data,
        } as Submission;
        submissionsArray.push(submission);
        return doc.data() as Submission;
      });

      setSubmissions(submissionsArray);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!submissions) {
      fetchData();
    }
  }, [submissions]);

  useEffect(() => {
    fetchData();
  }, [status]);

  const filteredSubmissions = submissions?.filter(
    (submission) => submission.status === status
  );

  return { data: filteredSubmissions, loading, error };
};
